<template>
<div>
     <b-modal v-model="modalShow" id="modal-lg" class="home-modal" size="lg" hide-footer="true">
            <CovidBanner />
            <!-- <img src="static/commercial/img/MMRemtechAwards.jpg" class="banner-img"  onclick="window.open('https://remtech.org/merchantrade-money-visa-prepaid-card/', '_blank')"> -->
        </b-modal>
<div class="sticky-container" sticky-container>
    <link rel="stylesheet" href="static/fonts/style.css" type="text/css">
    <div class="hero-section">

        <div class="banner-image">
            <img class="landscape-image" src="/static/commercial/img/header-banner.png" alt="">
            <img class="portrait-image" src="/static/commercial/img/header-banner01.png" alt="">
        </div>
        <!-- eo banner image -->
        <NavHeader />
        <!-- eo header -->

        <div class="hero-content">
            <div class="container">
                <div class="left-content">
                    <h2>Send money
                        <br>
                        <span>to over 200 countries</span>
                    </h2>
                </div>
                <!-- eo left content -->

                <div class="right-content">
                    <!-- <div class="conversion-box">
                            <div class="you-send pb-0">
                                <div class="form-group">
                                    <label>You send</label>
                                    <div class="main-form">
                                        <input type="text" v-model="options.fromAmount" class="form-control">

                                        <div class="currency">
                                            <div class="flag">
                                                <img src="/static/flags/my.png" alt="">
                                            </div>
                                            <span>MYR</span>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="conversion-detail">
                                <img src="/static/commercial/img/icons/arrows.png" alt="">
                                <span>1 MYR = {{vModel.ExchangeRate}} {{vModel.CurrencyCode}}</span>
                            </div>

                            <div class="you-get">
                                <div class="form-group">
                                    <label>Recipient gets</label>
                                    <div class="main-form">
                                        <input disabled type="text" v-model="options.toAmount" class="form-control text-red">

                                        <div class="currency-dropdown">
                                            <kendo-dropdownlist v-if="vModel.Rates != null" name='TransactionUrl' ref="kendoRecipient" class="dashboard-rate" v-model="vModel.ExchangeRateId"
                                                :data-value-field="'ExchangeRateId'" :data-value-text="'ExchangeRateId'" :valueTemplate="itemTemplate"
                                                :template="itemTemplate" :data-source="vModel.Rates" :data-value-primitive="true">
                                            </kendo-dropdownlist>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <router-link :to="'/account/login'" class="send-money-btn">Send Money Now!</router-link>

                        </div> -->
                    <!-- eo conversion box -->

                    <div class="eremit_sendmoney">

                        <div class="form-group">
                            <label>Select your receiver's country</label>

                            <kendo-dropdownlist v-if="CountryList!=null" name='CountryId' v-validate="'required'" class="form-control home-country" :class="{'input': true, 'is-danger': errors.has('CountryId') }" ref="countrydropdownlist" v-model="vModel.Id" :data-text-field="'CountryName'" :data-value-field="'Id'" :option-label="'Please Select Country'" :auto-bind="true" :data-source="CountryList" :data-value-primitive="true" @select="onCountryChange" data-vv-as='Country' :valueTemplate="countryItemTemplate" :template="countryItemTemplate">
                            </kendo-dropdownlist>
                        </div>
                        <div class="form-group">

                            <label>How does your receiver want the money?</label>

                            <div class="select-reciver-method" v-if="!vModel.Id">

                                <div class="method">
                                    <input class="method-radio ba" type="radio" id="BankAccount" name="PaymentMetodh">
                                    <label for="BankAccount">
                                        <span></span> Bank Account
                                    </label>
                                </div>
                                <!--end method-radio-->
                                <div class="method">
                                    <input class="method-radio cp" type="radio" id="CashPickup" name="PaymentMetodh">
                                    <label for="CashPickup">
                                        <span></span> Cash Pickup
                                    </label>
                                </div>
                                <!--end method-radio-->

                                <div class="method">
                                    <input class="method-radio mw" type="radio" id="MobileWallet" name="PaymentMetodh">
                                    <label for="MobileWallet">
                                        <span></span> Mobile Wallet
                                    </label>
                                </div>
                                <!--end method-radio-->
                            </div>
                            <!--end select-recveiver-method-->
                            <div class="select-reciver-method" v-if="vModel.Id">

                                <div class="method" v-for="(item, index) in SelectedCountryPaymentMode" :key="item.Id">
                                    <input type="radio" :id="'BankAccount_'+item.Id" name="PaymentMetodh" :value="item.Id" v-model="vModel.PaymentModeId" :class="getPaymentClass(item)">
                                    <label :for="'BankAccount_'+item.Id" @click="onClickPaymentMode(item)">
                                        <span></span> {{item.Name}}
                                    </label>
                                </div>

                            </div>
                            <!--end form-group-->
                        </div>

                        <div class="amount-exchnage">
                            <div class="ae-body">
                                <a class="exchnage-button" href="javascript:void(0)">
                                    <img src="static/img/icon-exchange.svg">
                                </a>
                                <div class="left">
                                    <div class="upper">
                                        <span>You Send</span>
                                        <span>MYR</span>
                                    </div>
                                    <div class="amt">
                                        <input type="text" v-only-numeric @keyup="onAmountKey('sendamount')" name="SendAmount" autocomplete="off" v-model="vModel.SendAmount" />
                                    </div>
                                </div>
                                <!--end left-->
                                <div class="right">
                                    <div class="upper">
                                        <span>Receiver Gets </span>
                                        <span>{{SelectedCountryData.CurrencyCode}}</span>
                                    </div>
                                    <div class="amt">
                                        <input type="text" v-only-numeric name="PayAmount" autocomplete="off" v-model="vModel.PayAmount" @keyup="onAmountKey('payamount')" />
                                    </div>
                                </div>
                                <!--end right-->
                            </div>
                            <div class="ae-foot">
                                <span>Exchange Rate : 1.00 MYR = {{vModel.ExchangeRate ? vModel.ExchangeRate.toFixed(4) :''}}
                                    {{SelectedCountryData.CurrencyCode}}</span>
                                <span>Service Fee : MYR {{vModel.TransferFee?vModel.TransferFee.toFixed(2):''}} </span>
                            </div>
                        </div>
                        <!--end amount exchnage -->
                        <div class="send_money">
                            <button class="btn-sendm" type="button" @click="onclickSend">Send Money Now !</button>
                        </div>
                    </div>

                </div>
                <!-- eo right content -->
            </div>
            <!-- eo container -->
        </div>
        <!-- eo hero content -->
    </div>
    <!-- eo hero section -->

    <!-- eo overlay main responsive header -->

    <!-- <div class="container">
                <div class="rate-slider">
                    <h3 class="rate-header">Today's Rates</h3>

                    <section class="items-slider slider" v-if="vModel.Rates != null">

                        <slick ref="slick" :options="slickOptions">
                            <div :key="rate.ExchangeRateId" v-for="rate in vModel.Rates">
                                <div class="items">
                                    <div class="flag-image">
                                        <img :src="'/static/flags/'+rate.FlagCode+'.png'" />
                                    </div>

                                    <div class="detail">
                                        <h6>1 MYR</h6>
                                        <h5>{{rate.ExchangeRate}} {{rate.CurrencyCode}}</h5>
                                    </div>

                                </div>
                            </div>
                        </slick>
                    </section>

                </div>

                <div class="other-rates">

                    <router-link :to="'/rate'" class="main-btn">View More Rates
                        <i class="material-icons">chevron_right</i>
                    </router-link>
                </div>
            </div> -->

    <div class="divider"></div>

    <div class="container">
        <div class="text-content-section">
            <h2 class="content-header">The best way to send money overseas</h2>

            <p class="content-para">Whether you’re looking to transfer money back home to your family, for your
                children’s education, for investment
                or savings purposes, eRemit is a safe and convenient way to make payments.</p>

            <div class="feature">
                <div class="row">
                    <div class="col-md-4 feature-list">
                        <img src="/static/commercial/img/icons/competitiveERate.png" alt="" />
                        <h3>Competitive Exchange Rates</h3>
                    </div>
                    <div class="col-md-4 feature-list">
                        <img src="/static/commercial/img/icons/fasttransfer.png" alt="" />
                        <h3>Fast Transfers</h3>
                    </div>
                    <div class="col-md-4 feature-list">
                        <img src="/static/commercial/img/icons/safesecure.png" alt="" />
                        <h3>Safe & Secure</h3>
                    </div>
                </div>
            </div>
            <!-- eo feature -->
        </div>
        <!-- eo text content section -->
    </div>
    <!-- eo container -->

    <!-- <div class="divider"></div> -->

    <div class="full-image">
        <img src="/static/commercial/img/map.JPG" alt="" />
    </div>

    <!-- <div class="divider divider-grey"></div> -->

    <div class="video-box">
        <div class="main-video">
            <a href="https://www.youtube.com/watch?v=8YDGr1Grno0">
                <img src="/static/commercial/img/pic-video-eremit-new.jpg" alt="" />
            </a>
            <!-- <video controls="controls" type="video/mp4" poster="/static/img/pic-video-eremit-new.jpg"> -->
            <!-- <source src="" type="video/mp4"> 
                    </video>-->
        </div>

        <div class="text-content">
            <p>Experience the convenience of sending money from the comfort of your home or office</p>
        </div>
    </div>

    <div class="business-mode">

        <div class="container">
            <div class="business-detail">
                <p>eRemit Business Payments</p>

                <h2>Save On Your Overseas Business Payments</h2>

                <p class="business-detail-para">eRemit Business is a fast, affordable way for Small and Medium
                    enterprises (SMEs) to make online payments
                    and purchases internationally, with built-in time-saving, easy-to-track features for
                    fast-paced businesses.</p>

                <router-link :to="'/business'" class="red-btn">More Details</router-link>
            </div>
        </div>

        <div class="business-image">
            <img src="/static/commercial/img/banner01.png" alt="" />
        </div>
    </div>
    <DownloadApp />
    <SignUpFooter />
    <div class="sticky" v-sticky="stickyEnabled" sticky-offset="offset" sticky-side="both" v-if="vModel.Promotions.length !=0">
        <promotion :items="vModel.Promotions" />
        <!-- <h2>
              <span>{{stickyEnabled ? 'Sticky' : 'Not sticky'}} {{stickyEnabled}}</span>
              <button class="toggle-sticky" @click="stickyEnabled = !stickyEnabled">toggle sticky</button>
            </h2> -->
    </div>
</div>
</div>
</template>

<script>
import Slick from "vue-slick";
import DownloadApp from "../../shared/commercial/DownloadApp.vue";
import NavHeader from "../../shared/commercial/NavHeader.vue";
import SignUpFooter from "../../shared/commercial/SignUpFooter.vue";
import ListService from "../../services/list";
import Promotion from '../../components/promotion'
import CovidBanner from "../../shared/CovidBanner"
import {
    _
} from 'vue-underscore';

import '@/../static/custom/jquery.smartbanner'

export default {
    name: "Dashboard",

    components: {
        SignUpFooter,
        DownloadApp,
        NavHeader,
        Slick,
        Promotion,
        CovidBanner
    },
    beforeRouteEnter(to, from, next) {
        Promise.all([
            ListService.get("list/exchangerate"),
            ListService.get('list/promotion/all'), ListService.get('v2/dashboard/initial')
        ]).then(responses => {
            next(vm => {
                var rates = [];
                responses[0].body.forEach(p => {
                    rates.push({
                        ExchangeRateId: p.ExchangeRateId,
                        FlagCode: p.FlagCode,
                        CurrencyCode: p.CurrencyCode,
                        CurrencyName: p.CurrencyName,
                        ExchangeRate: p.ExchangeRate
                    });
                });

                vm.vModel.Rates = rates;
                var rate = rates[0];
                // vm.vModel.ExchangeRateId = rate.ExchangeRateId;
                // vm.vModel.ExchangeRate = rate.ExchangeRate;
                vm.vModel.FlagCode = rate.FlagCode;
                vm.vModel.CurrencyCode = rate.CurrencyCode;
                vm.vModel.Promotions = responses[1].body;
                let cntrylist = responses[2].body;
                vm.CountryList = cntrylist.Countries.filter(x => x.MirsActive && x.PaymentNetworks.filter(y => y.Id = 1));
                // vm.SelectedCountryData=vm.CountryList[0];
                // vm.initViewModelValue(vm.SelectedCountryData);
            });
        });
    },
    watch: {
        "vModel.ExchangeRateId": function (newValue, oldValue) {
            var rate = this.vModel.Rates.filter(
                rate => rate.ExchangeRateId == newValue
            );
            // this.vModel.ExchangeRate = rate[0].ExchangeRate;
            this.vModel.FlagCode = rate[0].FlagCode;
            this.vModel.CurrencyCode = rate[0].CurrencyCode;

            this.options.toAmount = this.options.fromAmount ? (
                parseFloat(this.vModel.ExchangeRate) *
                parseFloat(this.options.fromAmount)
            ).toFixed(4) : 0;

            ga('send', 'event', 'Currency Convertor', 'Dropdown', this.vModel.CurrencyCode);
        },
        "options.fromAmount": function (newVal, oldVal) {
            this.options.toAmount = newVal ? (
                parseFloat(newVal) * parseFloat(this.vModel.ExchangeRate)
            ).toFixed(4) : 0;
        }
    },
    data() {
        return {
            modalShow: false,
            SelectedCountryData: {},
            SelectedCountryPaymentMode: [],
            itemTemplate: '<div class="m-b-sm m-t-sm"><img style="width:48px;margin-right:10px;" src="/static/flags/#:data.FlagCode#.png" />#:data.CurrencyCode#</div>',
            countryItemTemplate: '<img src="/static/flags/#:data.FlagCode#.png" height="25" width="25">&nbsp;<span>#:data.CountryName#</span>',
            slickOptions: {
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToScroll: 1,
                slidesToShow: 2,
                navigation: true,
                variableWidth: true,
                autoplay: true,
                autoplaySpeed: 1000
            },
            vModel: {
                Id: null,
                CurrencyCode: null,
                CurrencyId: null,
                PaymentModeId: null,
                SendAmount: 0.0,
                PayAmount: 0.0,
                PaymentNetworkId: 1,
                ExchangeRate: 0.0,
                TransferFee: 0.00,

                Rates: null,
                ExchangeRateId: null,
                Promotions: []
            },
            options: {
                fromAmount: 1,
                toAmount: null
            },
            offset: {
                top: 100,
                bottom: 0
            },
            stickyEnabled: true,
            CountryList: null,
            isProcessing: false,
        };
    },
    methods: {
        next() {
            this.$refs.slick.next();
        },

        prev() {
            this.$refs.slick.prev();
        },

        reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists

            this.$refs.slick.refresh();
        },
        fetchRate() {},
        onCountryChange(e) {
            if (e.dataItem.Id == "")
                this.SelectedCountryData = {};
            this.initViewModelValue({});

            if (this.vModel.Code == e.dataItem.Code) {
                return false;
            }
            this.SelectedCountryData = {};
            this.SelectedCountryPaymentMode = [];
            this.SelectedCountryData = e.dataItem;
            let payoutmodeList = this.SelectedCountryData.PaymentNetworks.filter(x => x.Id == 1)[0].PayoutModes;
            this.SelectedCountryPaymentMode = [...payoutmodeList]
            this.initViewModelValue(this.SelectedCountryData)
        },
        onPayoutModeClick(e) {

        },
        onAmountKey(item) {
            let self = this;
            if (item == 'sendamount') {
                if (!this.vModel.SendAmount)
                    this.vModel.PayAmount = '';

                if (isNaN(this.vModel.SendAmount) || !this.vModel.SendAmount || parseFloat(this.vModel.SendAmount) <= 0)
                    return;
                this.vModel.IsLocalCurrencyKeyIn = true;
                //this.vModel.SendAmount = this.vModel.SendAmount ? parseFloat(this.vModel.SendAmount).toFixed(2) : '';
                // this.vModel.PayAmount='';

            } else if (item == 'payamount') {
                this.vModel.IsLocalCurrencyKeyIn = false;
                if (!this.vModel.PayAmount)
                    this.vModel.SendAmount = '';
                if (isNaN(this.vModel.PayAmount) || !this.vModel.PayAmount || parseFloat(this.vModel.PayAmount) <= 0)
                    return;
                //this.vModel.PayAmount = this.vModel.PayAmount ? parseFloat(this.vModel.PayAmount).toFixed(2) : '';
                // this.vModel.SendAmount='';
            }
            this.onDebounceKeyup(this);
            // setTimeout(() => {
            //     self.getRate();
            // }, 2000);

        },

        onDebounceKeyup: _.debounce((vm) => {
            vm.getRate();
        }, 1000),

        getRate() {
            let self = this;

            if (!this.vModel.Id) {
                this.$toastr("error", "Please Select Country");
                return false
            } else if (!this.vModel.PaymentModeId) {
                this.$toastr("error", "Please Select Paymentmode");
                return false
            }
            if (this.vModel.IsLocalCurrencyKeyIn) {
                if (isNaN(this.vModel.SendAmount) || !this.vModel.SendAmount || parseFloat(this.vModel.SendAmount) <= 0)
                    return;

                this.vModel.SendAmount = this.vModel.SendAmount ? parseFloat(this.vModel.SendAmount).toFixed(2) : '';
                // this.vModel.PayAmount='';

            } else {
                if (isNaN(this.vModel.PayAmount) || !this.vModel.PayAmount || parseFloat(this.vModel.PayAmount) <= 0)
                    return;
                this.vModel.PayAmount = this.vModel.PayAmount ? parseFloat(this.vModel.PayAmount).toFixed(2) : '';
                // this.vModel.SendAmount='';
            }
            // if(self.isProcessing)
            //     return false;
            // self.isProcessing = true;

            self.$http
                .post("v2/transaction/exchangerate", {
                    CountryId: this.vModel.Id,
                    PaymentNetworkId: this.vModel.PaymentNetworkId,
                    PaymentModeId: this.vModel.PaymentModeId,
                    CurrencyId: this.vModel.CurrencyId,
                    SendAmount: this.vModel.SendAmount ? parseFloat(this.vModel.SendAmount) : 0,
                    PayAmount: this.vModel.PayAmount ? parseFloat(this.vModel.PayAmount) : 0,
                    IsLocalCurrencyKeyIn: this.vModel.IsLocalCurrencyKeyIn,
                }).then(res => {
                        // self.isProcessing = false;
                        self.vModel.ExchangeRate = res.body.ExchangeRate;

                        // self.vModel.SendAmount=res.body.SendAmount;
                        self.vModel.TransferFee = res.body.TransferFee;
                        if (self.vModel.IsLocalCurrencyKeyIn) {
                            self.vModel.PayAmount = parseFloat(res.body.PayAmount).toFixed(2);
                        } else {
                            self.vModel.SendAmount = parseFloat(res.body.SendAmount).toFixed(2);
                        }
                    },
                    err => {
                        // self.isProcessing = false;
                    });
        },
        onClickPaymentMode(item) {
            if (item.Id == this.vModel.PaymentModeId)
                return;
            this.vModel.PaymentModeId = item.Id;
            this.getRate();
        },
        getPaymentClass(item) {
            let cls = 'method-radio ';
			if (item.Id == "1" || item.Id == "21") {
                cls += "ba"
            } else if (item.Id == "2") {
                cls += "cp"

            } else {
                cls += "mw"
            }
            return cls;
        },
        initViewModelValue(obj) {
            this.vModel.Id = obj.Id,
                this.vModel.CurrencyCode = obj.CurrencyCode;
            this.vModel.CurrencyId = obj.CurrencyId;
            this.vModel.SendAmount = 0.0;
            this.vModel.PayAmount = 0.0;
            this.vModel.ExchangeRate = 0.0;
            this.vModel.TransferFee = 0.0;
            this.vModel.PaymentModeId = 0;
            this.vModel.PaymentNetworkId = 1;
        },
        onclickSend(e) {
            ga('send', 'event', 'Button', 'Click', 'Send Money Now');
            this.$router.push('/account/login');
        },
        removeSmartBannerCookies() {
            //Manually Remove SmartBanner Cookies
            document.cookie = 'sb-closed=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'sb-closed=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

            document.cookie = 'sb-installed=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'sb-installed=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        },
        
    },
    mounted() {       
        var android = location.href.match(/#android$/) || navigator.userAgent.match(/Android/i) != null;
        this.removeSmartBannerCookies();

        setTimeout(() => {
            $.smartbanner({
                title: 'e-Remit', // What the title of the app should be in the banner (defaults to <title>)
                author: 'Merchantrade Asia Sdn Bhd', // What the author of the app should be in the banner (defaults to <meta name="author"> or hostname)
                price: 'Get it', // Price of the app
                appStoreLanguage: 'us', // Language code for App Store
                inAppStore: 'on the App Store', // Text of price for iOS
                inGooglePlay: 'on Google Play', // Text of price for Android
                icon: '/static/img/icons/eremit-icon.png', // The URL of the icon (defaults to <link>)
                iconGloss: null, // Force gloss effect for iOS even for precomposed (true or false)
                button: 'VIEW', // Text on the install button
                scale: 'auto', // Scale based on viewport size (set to 1 to disable)
                speedIn: 300, // Show animation speed of the banner
                speedOut: 400, // Close animation speed of the banner
                daysHidden: 0, // Duration to hide the banner after being closed (0 = always show banner)
                daysReminder: 0, // Duration to hide the banner after "VIEW" is clicked (0 = always show banner)
                force: android ? 'android' : 'ios', // Choose 'ios' or 'android'. Don't do a browser check, just always show this banner
                url: android ? "https://play.google.com/store/apps/details?id=com.app.mtaeremit&hl=en" : "https://itunes.apple.com/us/app/e-remit/id1060407677?mt=8"
           });
        }, 1000);


    },
    destroyed() {
        //For hiding SmartBanner in other page. SmartBanner must appear in home page only.
        if (document.getElementById("smartbanner")) {
            this.removeSmartBannerCookies();
            document.getElementById("smartbanner").style.setProperty("display", "none", "important");
            document.getElementsByTagName("html")[0].style.setProperty("margin-top", "0", "important");
        }

    }
}
</script>

<style scoped>
@import "/static/custom/jquery.smartbanner.css";
</style><style>
.eremit_sendmoney .form-group label {
    margin-bottom: 10px;
    display: block;
}

.eremit_sendmoney .form-group .select-reciver-method {
    border: 0;
    border-radius: 7px;
    display: flex;
    justify-content: space-around;
}

.eremit_sendmoney .form-group .select-reciver-method:hover {
    cursor: pointer;
}

.eremit_sendmoney .form-group .select-reciver-method .method {
    text-align: center;
}

.eremit_sendmoney .form-control {
    width: 100%;
    border-radius: 10px;
    font-size: inherit;
    font-family: 'Montserrat', sans-serif;
}

/*select metodh*/
.eremit_sendmoney .method-radio {
    display: none;
}

.eremit_sendmoney .method-radio+label {
    font-weight: 400;
    cursor: pointer;
    color: #555;
    line-height: 12px;
    padding: 15px 7px;
    font-weight: 500;
    background: #fff;
    border-radius: 9px;
    font-size: 14px;
}

.eremit_sendmoney .method-radio+label span {
    display: block;
    vertical-align: middle;
    /*margin-right: 5px;*/
    font-size: 28px;
    height: 38px;
    cursor: pointer;
    border-radius: 50%;
    position: relative;
    display: block;
    color: #555;
}

.eremit_sendmoney .method-radio+label span::before {
    opacity: 0.9;
    disply: block;
    -moz-transition: opacity 0.2s;
    -o-transition: opacity 0.2s;
    -webkit-transition: opacity 0.2s;
    transition: opacity 0.2s;
}

.eremit_sendmoney .method-radio:checked+label {
    background: #dE202F;
    color: #fff;
    border-radius: 15px;
}

.eremit_sendmoney .method-radio:checked+label span::before {
    color: #fff;
    opacity: 1;
}

	.eremit_sendmoney .method-radio.ba + label span::before {
		content: "account_balance";
		font-size: 40px;
		font-family: 'Material Icons' !important;
	}

	.eremit_sendmoney .method-radio.cp + label span::before {
		content: "local_atm";
		font-size: 40px;
		font-family: 'Material Icons' !important;
	}

	.eremit_sendmoney .method-radio.mw + label span::before {
		content: "account_balance_wallet";
		font-size: 40px;
		font-family: 'Material Icons' !important;
	}

	.eremit_sendmoney .method-radio.hd + label span::before {
		content: "local_shipping";
		font-size: 40px;
		font-family: 'Material Icons' !important;
	}

.eremit_sendmoney .amount-exchnage .ae-body {
    display: flex;
    position: relative;
    /*End Left*/
    /*right*/
    background: #fff;
}

.eremit_sendmoney .amount-exchnage .ae-body .exchnage-button {
    position: absolute;
    background: white;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    line-height: 41px;
    border: 1px solid #ddd;
    text-align: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.eremit_sendmoney .amount-exchnage .ae-body .exchnage-button img {
    width: 14px;
}

.eremit_sendmoney .amount-exchnage .ae-body .left {
    -ms-flex-preferred-size: 50%;
    flex-basis: 50%;
    border: 1px solid #e1e1e1;
    padding: 8px 15px;
    padding-right: 27px;
    border-left: 0;
    padding-bottom: 0;
    background: #fdfdfd;
}

.eremit_sendmoney .amount-exchnage .ae-body .left .upper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 7px;
    font-weight: 600;
}

.eremit_sendmoney .amount-exchnage .ae-body .left .upper span:first-child {
    flex-basis: 90%;
    text-align: left;
}

.eremit_sendmoney .amount-exchnage .ae-body .left .upper span:last-child {
    flex-basis: 10%;
    text-align: right;
}

.amount-exchnage .ae-body .left .amt {
    font-size: 30px;
    text-align: right;
}

.eremit_sendmoney .amount-exchnage .ae-body .left .amt input {
    background: transparent;
    border: 0;
    font-size: 31px;
    max-width: 100%;
    text-align: right;
    width: 100%;
    font-family: 'Montserrat', sans-serif;
}

.eremit_sendmoney .amount-exchnage .ae-body .left .amt input:focus {
    border: 0;
    outline: none;
}

.amount-exchnage .ae-body .right {
    -ms-flex-preferred-size: 50%;
    flex-basis: 50%;
    padding: 8px 15px;
    border: 1px solid #e1e1e1;
    border-right: 0;
    padding-bottom: 0;
    background: #fdfdfd;
}

.eremit_sendmoney .amount-exchnage .ae-body .right .upper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 7px;
    font-weight: 600;
}

.eremit_sendmoney .amount-exchnage .ae-body .right .upper span:first-child {
    flex-basis: 90%;
    text-align: left;
}

.eremit_sendmoney .amount-exchnage .ae-body .right .upper span:last-child {
    flex-basis: 10%;
    text-align: right;
}

.eremit_sendmoney .amount-exchnage .ae-body .right .amt {
    font-size: 30px;
    text-align: right;
}

.eremit_sendmoney .amount-exchnage .ae-body .right .amt input {
    background: transparent;
    border: 0;
    font-size: 31px;
    max-width: 100%;
    text-align: right;
    width: 100%;
    font-family: 'Montserrat', sans-serif;
}

.eremit_sendmoney .amount-exchnage .ae-body .right .amt input:focus {
    border: 0;
    outline: none;
}

.eremit_sendmoney .amount-exchnage .ae-foot {
    background: #112339;
    padding: 5px;
    text-align: center;
    border-radius: 0 0 15px 15px;
    color: #fff;
    padding-bottom: 38px;
}

.eremit_sendmoney .amount-exchnage .ae-foot .app-foot-nav span {
    display: block;
}

.eremit_sendmoney .amount-exchnage .ae-foot .app-foot-nav span:first-child {
    margin-bottom: 4px;
}

.eremit_sendmoney {
    max-width: 410px;
    margin: 0 auto;
    background: hsla(0, 0%, 100%, .95);
    border-radius: 15px;
    padding-top: 14px;
}

.eremit_sendmoney .amount-exchnage {
    margin-top: 5px;
}

.eremit_sendmoney .form-group {
    padding: 0px 14px;
}

.eremit_sendmoney .ae-foot span {
    display: block;
}

.eremit_sendmoney .right .amt input {
    color: red;
    font-weight: 500;
}

.send_money {
    text-align: center;
}

.send_money .btn-sendm {
    background: #34B74D;
    border: 0;
    padding: 11px;
    color: #fff;
    border-radius: 28px;
    max-width: 279px;
    width: 100%;
    font-weight: 500;
    font-size: 19px;
    bottom: -16px;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    cursor: pointer;
}

.send_money {
    position: relative;
}

.eremit_sendmoney span.k-dropdown-wrap.k-state-default {
    background: white !important;
}

@media only screen and (max-width: 1256px) and (min-width: 1150px) {
    .eremit_sendmoney {
        margin-top: 45px !important;
    }

}

@media only screen and (max-width: 900px) and (min-width: 768px) {
    .eremit_sendmoney {
        margin-top: -70px;

    }

    .commercial-website .hero-section .hero-content .right-content {
        width: 49%;
    }

}

@media only screen and (max-width: 990px) and (min-width: 768px) {

    .text-content-section {
        margin-top: 40px;
    }

}

 #smartbanner{
			top: -79px !important;
		} 

.home-country{
     border: 0;     
     display: -webkit-box;
 }
</style>

